import { SERVICE_CATEGORY_PATH } from './sidebar/common';

// Affiliate paths
/** @deprecated */ export const ACCOUNT_PATH = '/account';
/** @deprecated */ export const ACCOUNT_DASHBOARD_PATH = `${ACCOUNT_PATH}/dashboard`;
/** @deprecated */ export const ACCOUNT_MODELS_PATH = `${ACCOUNT_PATH}/models`;
/** @deprecated */ export const ACCOUNT_PAYOUTS_PATH = `${ACCOUNT_PATH}/payouts`;
/** @deprecated */ export const ACCOUNT_STATISTICS_PATH = `${ACCOUNT_PATH}/statistics`;
/** @deprecated */ export const ACCOUNT_REFERRALS_PATH = `${ACCOUNT_PATH}/referrals`;
/** @deprecated */ export const ACCOUNT_CPL_PATH = `${ACCOUNT_PATH}/cpl`;

/** @deprecated */ export const LIBRARY_PATH = '/library';
/** @deprecated */ export const LIBRARY_BANNERS_PATH = `${LIBRARY_PATH}/banners`;
/** @deprecated */ export const LIBRARY_PRE_ROLLS_PATH = `${LIBRARY_PATH}/pre-rolls`;
/** @deprecated */ export const LIBRARY_LANDING_PAGE_BUILDER = `${LIBRARY_PATH}/landing-page-builder`;
/** @deprecated */ export const LIBRARY_POPUNDERS_PATH = `${LIBRARY_PATH}/popunders`;

/** @deprecated */ export const LIBRARY_SMART_POPUNDERS_LIST_PATH = `${LIBRARY_PATH}/smart-popunders`;

/** @deprecated */ export const LIBRARY_MODELS_BOOST = `${LIBRARY_PATH}/models-boost`;

/** @deprecated */ export const LIBRARY_WHITE_LABELS_PATH = `${LIBRARY_PATH}/white-labels`;
/** @deprecated */ export const LIBRARY_WIDGETS_PATH = `${LIBRARY_PATH}/widgets`;
/** @deprecated */ export const LIBRARY_LINKS_BUILDER_PATH = `${LIBRARY_PATH}/links-builder`;

/** @deprecated */ export const NEWS_PATH = '/news';

/** @deprecated */ export const SETTINGS_PATH = '/settings';
/** @deprecated */ export const ACCOUNT_SETTINGS_PATH = `${SETTINGS_PATH}/account`;
/** @deprecated */ export const PAYOUT_SETTINGS_PATH = `${SETTINGS_PATH}/payout`;
/** @deprecated */ export const POSTBACK_SETTINGS_PATH = `${SETTINGS_PATH}/postback`;
/** @deprecated */ export const SECRETS_SETTINGS_PATH = `${SETTINGS_PATH}/secrets`;

/** @deprecated */ export const DOCUMENTATION_PATH = '/documentation';
/** @deprecated */ export const POSTBACKS_DOCUMENTATION_PATH = `${DOCUMENTATION_PATH}/postbacks`;

/** @deprecated */ export const SERVICE_POSTBACK_PARAMS_PATH = `${SERVICE_CATEGORY_PATH}/postback-guide`;

// Manager paths
/** @deprecated */ export const STATISTICS_PATH = '/statistics';
/** @deprecated */ export const STATISTICS_NEW_SUMMARY_PATH = `${STATISTICS_PATH}/new-summary`;
/** @deprecated */ export const STATISTICS_MODELS_PATH = `${STATISTICS_PATH}/models`;

/** @deprecated */ export const USERS_PATH = '/users';
/** @deprecated */ export const USERS_USERS_PATH = `${USERS_PATH}/users`;
/** @deprecated */ export const USERS_INVITES_PATH = `${USERS_PATH}/invites`;
/** @deprecated */ export const USERS_CUSTOM_CPL_SETTINGS_PATH = `${USERS_PATH}/custom-cpl-settings`;
/** @deprecated */ export const USERS_TRAFFIC_ANALYZER_PATH = `${USERS_PATH}/traffic-analyzer`;
/** @deprecated */ export const USERS_PAYOUT_SETTINGS_PATH = `${USERS_PATH}/payout`;
/** @deprecated */ export const USERS_SMART_URL_PATH = `${USERS_PATH}/smart-url`;

/** @deprecated */ export const PAYOUTS_PATH = '/payouts';
/** @deprecated */ export const PAYOUTS_DEDUCTIONS_PATH = `${PAYOUTS_PATH}/deductions`;

/** @deprecated */ export const NEWS_ITEM_PATH = '/news-item';
/** @deprecated */ export const NEWS_ITEM_CREATE_PATH = `${NEWS_ITEM_PATH}/create`;

/** @deprecated */ export const LTV_PATH = '/ltv';
/** @deprecated */ export const LTV_STATISTICS_PATH = `${LTV_PATH}/statistics`;

const LOGS_PATH = '/logs';

/** @deprecated */ export const AUDIT_LOG_PATH = `${LOGS_PATH}/audit-log`;
/** @deprecated */ export const POSTBACKS_LOG_PATH = `${LOGS_PATH}/postbacks-log`;
